import { useTranslation } from 'react-i18next'

import { ArrowClockwiseIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, Text } from '@reveni-io/reveni-ui'

import { reloadPage } from './helpers'
import * as Styles from './styles'

const VersionNotification = ({ show }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!show) return null

  const handleRefresh = () => {
    reloadPage()
  }

  return (
    <Styles.Container data-testid="version-notification">
      <Text type="bodyMBold" color={theme.colors.text.inverse}>
        {t('Hay una nueva versión disponible.')}
      </Text>
      <Button variant="text" onClick={handleRefresh} data-testid="version-refresh-button">
        <ArrowClockwiseIcon size={16} color={theme.colors.text.inverse} weight="bold" />
        <Text type="bodySBold" color={theme.colors.text.inverse}>
          {t('Refrescar')}
        </Text>
      </Button>
    </Styles.Container>
  )
}

export default VersionNotification
